import React from "react";
import * as S from "./Widget.styles";
import { WidgetType } from "../../pages/Dashboard.data";
import { AnimatePresence } from "framer-motion";

// Interfaz de las props del componente
interface WidgetProps {
  data: WidgetType;
  isFocused: boolean;
  isOtherFocused: boolean;
  onFocus: () => void;
  onBlur: () => void;
}

const Widget: React.FC<WidgetProps> = ({
  data,
  isFocused,
  isOtherFocused,
  onFocus,
  onBlur,
}) => {
  const hasInteraction = !!data.interactionType;
  const subMenuPosition = data.submenuPosition || "right";
  const slideDirection = subMenuPosition === "left" ? 20 : -20;

  const subMenuVariants = {
    hidden: { opacity: 0, x: slideDirection },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        staggerChildren: 0.07,
      },
    },
  };

  const subItemVariants = {
    hidden: { opacity: 0, x: slideDirection },
    visible: { opacity: 1, x: 0 },
  };

  return (
    <S.WidgetContainer
      hasInteraction={hasInteraction}
      isOtherFocused={isOtherFocused}
      onMouseEnter={hasInteraction ? onFocus : undefined}
      onMouseLeave={hasInteraction ? onBlur : undefined}
      whileHover={{
        scale: 1.05,
        boxShadow: "0 10px 30px rgba(0, 0, 0, 0.2)",
      }}
      animate={{
        zIndex: isFocused ? 10 : 1,
      }}
      transition={{ layout: { duration: 0.3, type: "spring" } }}
      layout
    >
      <S.WidgetLinkWrapper to={data.path}>
        <S.WidgetHeader>
          {/* SE INVIERTE EL ORDEN: ÍCONO ARRIBA, TÍTULO ABAJO */}
          <S.IconWrapper>
            {data.iconComponent ? (
              <data.iconComponent />
            ) : data.icon ? (
              <data.icon />
            ) : null}
          </S.IconWrapper>
          <S.Title>{data.title}</S.Title>
        </S.WidgetHeader>
      </S.WidgetLinkWrapper>

      {/* Lógica para mostrar el submenú animado */}
      <AnimatePresence>
        {isFocused && data.subItems && (
          <S.SideSubMenu
            position={subMenuPosition}
            variants={subMenuVariants}
            initial="hidden"
            animate="visible"
            exit="hidden"
          >
            {data.subItems.map((item) => (
              <S.SideSubMenuItem
                key={item.name}
                to={item.path}
                variants={subItemVariants}
              >
                {item.name}
              </S.SideSubMenuItem>
            ))}
          </S.SideSubMenu>
        )}
      </AnimatePresence>
    </S.WidgetContainer>
  );
};

export default Widget;